import axios from 'axios';
import { getTenantToken, removeTenantToken } from './TenantToken';
import { removeTenantSession } from './TenantStorage';

export const apiTenant = axios.create({
  baseURL: process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'https://api.blocob3.com.br/',
})

apiTenant.interceptors.request.use(async config => {
  const token = getTenantToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

apiTenant.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401 &&
        !error.config.url?.includes('/tenant/login/') &&
        !error.config.url?.includes('/tenant/validate/')) {
      removeTenantToken();
      removeTenantSession();
      window.location.href = '/login/area-cliente';
    }

    return Promise.reject(error);
  }
);
